import React from "react";
import { useLocation } from "react-router-dom";
import "./AboutUsSection.css";

const AboutUsSection = () => {
  const location = useLocation();

  return (
    <section className="about-us-section">
      <div className="about-content">
        {/* Left: Image */}
        <div className="about-image">
          <img src="/logo.png" alt="About Us" loading="lazy" />
        </div>

        {/* Right: Text Content */}
        <div className="about-text">
          <h2>About Us</h2>
          <p>
            We are passionate about making your travel dreams come true. Explore
            the world with our tailor-made tours and personalized experiences.
          </p>
          {/* Hide the button if the current URL is "/about-us" */}
          {location.pathname !== "/about-us" && (
            <a href="/about-us">
              <button className="btn-learn-more">Learn More</button>
            </a>
          )}
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;
